import {useSiteLanguage} from "../../career/SiteLanguage";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../styles/mudur/ShiftLayout.css";
import "../../styles/mudur/VardiyaPlanlama.css";
import Puantaj from "./Puantaj";
import "../../styles/mudur/Puantaj.css";
import VardiyaGunlukRapor from "./VardiyaGunlukRapor";
import SayfaYardimPopup from "./SayfaYardimPopup";
import Navbar from "../../components/Navbar";
import PersonnelPhoto from '../../career/PersonnelPhoto';
import {
    ArrowLeft,
    CalendarClock,
    ClipboardList,
    FileText,
    LayoutDashboard,
    PanelLeftClose,
    PanelLeftOpen,
    UserRound,
} from "lucide-react";

const gunler = ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"];

const varsayilanVardiyaSecenekleri = [];


const metinKey = (value = "") => {
    return String(value || "")
        .trim()
        .toLocaleLowerCase("tr-TR");
};

const yeniPersonelSablonFormu = () => ({
    ad: "",
    aktifMi: true,
});

const getMonday = (date) => {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);

    d.setDate(diff);
    d.setHours(0, 0, 0, 0);

    return d;
};

const addDays = (date, count) => {
    const d = new Date(date);
    d.setDate(d.getDate() + count);
    return d;
};

const formatDate = (date,lang='tr') => {
    return date.toLocaleDateString(lang, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};

const formatDateForApi = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

const getIsoWeekNumber = (date) => {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;

    d.setUTCDate(d.getUTCDate() + 4 - dayNum);

    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);

    return weekNo;
};

const getHaftaBilgisi = (date) => {
    return `${getIsoWeekNumber(date)}. Hafta`;
};

const getWeekKey = (date) => {
    return getMonday(date).toISOString().split("T")[0];
};

const apiArrayGetir = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.data?.$values)) return payload.data.$values;
    if (Array.isArray(payload?.$values)) return payload.$values;
    if (Array.isArray(payload?.items)) return payload.items;
    if (Array.isArray(payload?.data?.items)) return payload.data.items;

    return [];
};

const lokasyonAdinaGoreSirala = (liste = []) => {
    return [...liste].sort((a, b) =>
        String(a.ad || "").localeCompare(String(b.ad || ""), "tr")
    );
};

const lokasyonOrgIdGetir = (lokasyon = {}) => {
    return lokasyon.organizasyonBirimiId || lokasyon.id;
};

const lokasyonunAltBirimiVarMi = (lokasyon, tumLokasyonlar = []) => {
    const orgId = lokasyonOrgIdGetir(lokasyon);

    return tumLokasyonlar.some(
        (item) => String(item.ustBirimId) === String(orgId)
    );
};

const lokasyonSelectListesiOlustur = (liste = []) => {
    const tumListe = apiArrayGetir(liste).filter(Boolean);
    const eklenenler = new Set();
    const sonuc = [];

    const ustLokasyonlar = lokasyonAdinaGoreSirala(
        tumListe.filter((lokasyon) =>
            lokasyonunAltBirimiVarMi(lokasyon, tumListe)
        )
    );

    ustLokasyonlar.forEach((ustLokasyon) => {
        const ustOrgId = lokasyonOrgIdGetir(ustLokasyon);

        sonuc.push({
            ...ustLokasyon,
            gorunenAd: `▸ ${String(ustLokasyon.ad || "").toLocaleUpperCase("tr-TR")}`,
            seviye: 0,
            anaBaslikMi: true,
        });

        eklenenler.add(String(ustLokasyon.id));

        const altLokasyonlar = lokasyonAdinaGoreSirala(
            tumListe.filter(
                (lokasyon) =>
                    String(lokasyon.ustBirimId) === String(ustOrgId) &&
                    String(lokasyon.id) !== String(ustLokasyon.id)
            )
        );

        altLokasyonlar.forEach((altLokasyon) => {
            sonuc.push({
                ...altLokasyon,
                gorunenAd: `   - ${altLokasyon.ad}`,
                seviye: 1,
                anaBaslikMi: false,
            });

            eklenenler.add(String(altLokasyon.id));
        });
    });

    const bagimsizLokasyonlar = lokasyonAdinaGoreSirala(
        tumListe.filter((lokasyon) => !eklenenler.has(String(lokasyon.id)))
    );

    bagimsizLokasyonlar.forEach((lokasyon) => {
        sonuc.push({
            ...lokasyon,
            gorunenAd: lokasyon.ad,
            seviye: 0,
            anaBaslikMi: false,
        });
    });

    return sonuc;
};



const getAvatarText = (adSoyad = "") => {
    return adSoyad
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((x) => x[0])
        .join("")
        .toUpperCase();
};

const kullanicilariPersonelFormatinaCevir = (kullanicilar = []) => {
    return kullanicilar.map((kullanici) => {
        const adSoyad =
            kullanici.adSoyad ||
            kullanici.adSoyadFull ||
            kullanici.fullName ||
            kullanici.name ||
            kullanici.userName ||
            `${kullanici.ad || ""} ${kullanici.soyad || ""}`.trim() ||
            "-";

        const kullaniciId =
            kullanici.kullaniciId ||
            kullanici.id ||
            kullanici.userId;

        return {
            id: String(kullaniciId),
            kullaniciId: String(kullaniciId),
            ad: adSoyad,
            pozisyonId:
                kullanici.pozisyonId ||
                kullanici.pozisyonID ||
                kullanici.organizasyonPozisyonId ||
                kullanici.aktifPozisyonId ||
                "",
            pozisyon: kullanici.pozisyon || kullanici.pozisyonAdi || "-",
            etiket: kullanici.grupAdi || kullanici.etiket || kullanici.departman || "",
            reyonSablonId:
                kullanici.reyonSablonId ||
                kullanici.personelSablonId ||
                kullanici.sablonId ||
                "",
            avatar: getAvatarText(adSoyad),
            foto: kullanici.foto || kullanici.fotoUrl || kullanici.profilePhotoUrl || kullanici.profilFotoUrl || "",
            profilFotoUrl: kullanici.profilFotoUrl || "",
            profilFotoEndpoint: kullanici.profilFotoEndpoint || "",
            shiftler: ["", "", "", "", "", "", ""],
        };
    });
};

function ShiftYonetimi() {
  const {tx,lang} = useSiteLanguage();
    const navigate = useNavigate();

    const [aktifShiftSayfa, setAktifShiftSayfa] = useState("planlama");
    const [sidebarAcik, setSidebarAcik] = useState(true);
    const [sidebarHover, setSidebarHover] = useState(false);
    const sidebarGorunur = sidebarAcik || sidebarHover;
    const tabloScrollRef = useRef(null);
    const altScrollRef = useRef(null);
    const [tabloScrollWidth, setTabloScrollWidth] = useState(0);
    const [altScrollStyle, setAltScrollStyle] = useState({
        left: 0,
        width: 0,
    });


    const [profilePhoto, setProfilePhoto] = useState(null);

    const kullaniciAdi = localStorage.getItem("userName") || "Personel";
    const kullaniciEmail = localStorage.getItem("userEmail") || "E-posta";
    const token = localStorage.getItem("token");
    const magazaMuduruMu = localStorage.getItem("magazaMuduruMu") === "true";

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const authHeader = {
        Authorization: `Bearer ${token}`,
    };

    const [haftaBaslangic, setHaftaBaslangic] = useState(getMonday(new Date()));
    const [personeller, setPersoneller] = useState([]);
    const planRequestRef = useRef(null);
    const [undoGecmisi, setUndoGecmisi] = useState([]);
    const [lokasyonlar, setLokasyonlar] = useState([]);
    const lokasyonSelectListesi = useMemo(() => {
        return lokasyonSelectListesiOlustur(lokasyonlar);
    }, [lokasyonlar]);
    const [vardiyaSecenekleri, setVardiyaSecenekleri] = useState(varsayilanVardiyaSecenekleri);
    const [seciliLokasyonId, setSeciliLokasyonId] = useState("");
    const [veriYukleniyor, setVeriYukleniyor] = useState(false);
    const [apiHata, setApiHata] = useState("");
    const [bildirim, setBildirim] = useState({
        acik: false,
        tip: "success",
        mesaj: "",
    });
    const [yardimAcik, setYardimAcik] = useState(false);



    const [seciliPersoneller, setSeciliPersoneller] = useState([]);
    const [optionsOpen, setOptionsOpen] = useState(false);
    const [arama, setArama] = useState("");
    const [pozisyonFiltre, setPozisyonFiltre] = useState("");
    const [dropdownHucre, setDropdownHucre] = useState(null);
    const [sayfa, setSayfa] = useState(1);
    const [sayfaBoyutu, setSayfaBoyutu] = useState(10);
    const dropdownButtonRef = useRef(null);
    const bildirimTimerRef = useRef(null);
    const [dropdownPozisyon, setDropdownPozisyon] = useState({ top: 0, left: 0, });
    const [kopyalananSatir, setKopyalananSatir] = useState(null);
    const [seciliSablonFiltre, setSeciliSablonFiltre] = useState("");
    const [personelSablonlari, setPersonelSablonlari] = useState([]);
    const [personelSablonYukleniyor, setPersonelSablonYukleniyor] = useState(false);
    const [personelSablonForm, setPersonelSablonForm] = useState(yeniPersonelSablonFormu());
    const [duzenlenenPersonelSablonId, setDuzenlenenPersonelSablonId] = useState(null);
    const [silinecekPersonelSablon, setSilinecekPersonelSablon] = useState(null);
    const [kaydedilenReyonPersonelId, setKaydedilenReyonPersonelId] = useState(null);

    const [ozelVardiyaModal, setOzelVardiyaModal] = useState({
        acik: false,
        personelId: "",
        gunIndex: null,
        baslangicSaati: "09:00",
        bitisSaati: "18:00",
        molaDakika: "",
        aciklama: "",
    });

    const haftaKey = useMemo(() => {
        const lokasyonKey = seciliLokasyonId || "lokasyon-yok";
        return `shift-plan-${lokasyonKey}-${getWeekKey(haftaBaslangic)}`;
    }, [seciliLokasyonId, haftaBaslangic]);

    const haftaTarihleri = useMemo(() => {
        return gunler.map((_, index) => addDays(haftaBaslangic, index));
    }, [haftaBaslangic]);

    const sablonVardiyaSecenekleri = useMemo(() => {
        return vardiyaSecenekleri.filter((item) => !item.ozelVardiyaMi);
    }, [vardiyaSecenekleri]);

    const pozisyonSecenekleri = useMemo(() => {
        const pozisyonlar = personeller
            .map((p) => p.pozisyon)
            .filter((pozisyon) => pozisyon && pozisyon !== "-");

        return [...new Set(pozisyonlar)].sort((a, b) =>
            a.localeCompare(b, "tr")
        );
    }, [personeller]);


    const seciliLokasyonApiId = useMemo(() => {
        if (!seciliLokasyonId) return "";

        const lokasyon = lokasyonlar.find(
            (item) =>
                String(item.id) === String(seciliLokasyonId) ||
                String(lokasyonOrgIdGetir(item)) === String(seciliLokasyonId)
        );

        return lokasyon ? lokasyonOrgIdGetir(lokasyon) : seciliLokasyonId;
    }, [lokasyonlar, seciliLokasyonId]);


    const aktifPersonelSablonlari = useMemo(() => {
        return personelSablonlari.filter((sablon) => sablon.aktifMi !== false);
    }, [personelSablonlari]);

    const sablonFiltreSecenekleri = useMemo(() => {
        return aktifPersonelSablonlari
            .map((sablon) => ({
                id: sablon.id,
                ad: sablon.ad,
            }))
            .filter((sablon) => sablon.id && sablon.ad)
            .sort((a, b) => String(a.ad).localeCompare(String(b.ad), "tr"));
    }, [aktifPersonelSablonlari]);

    const sablonUyeIdSet = useMemo(() => {
        if (!seciliSablonFiltre) return null;

        const sablon = aktifPersonelSablonlari.find(
            (item) => String(item.id) === String(seciliSablonFiltre)
        );

        if (!sablon) return null;

        return new Set(
            apiArrayGetir(sablon.kullaniciIdleri)
                .map((id) => String(id))
                .filter(Boolean)
        );
    }, [aktifPersonelSablonlari, seciliSablonFiltre]);

    const personelReyonSablonIdGetir = (personel) => {
        const mevcutSablonId =
            personel.reyonSablonId ||
            personel.personelSablonId ||
            personel.sablonId ||
            "";

        if (mevcutSablonId) {
            return String(mevcutSablonId);
        }

        const kullaniciId = String(personel.kullaniciId || personel.id || "");

        if (!kullaniciId) return "";

        const bulunanSablon = aktifPersonelSablonlari.find((sablon) =>
            apiArrayGetir(sablon.kullaniciIdleri)
                .map((id) => String(id))
                .includes(kullaniciId)
        );

        return bulunanSablon ? String(bulunanSablon.id) : "";
    };


    const filtreliPersoneller = useMemo(() => {
        const q = arama.trim().toLocaleLowerCase("tr-TR");
        const seciliPozisyon = pozisyonFiltre.trim().toLocaleLowerCase("tr-TR");

        return personeller.filter((p) => {
            const ad = String(p.ad || "").toLocaleLowerCase("tr-TR");
            const pozisyon = String(p.pozisyon || "").toLocaleLowerCase("tr-TR");
            const etiket = String(p.etiket || "").toLocaleLowerCase("tr-TR");

            const aramaMatch =
                !q ||
                ad.includes(q) ||
                pozisyon.includes(q) ||
                etiket.includes(q);

            const pozisyonMatch =
                !seciliPozisyon || pozisyon === seciliPozisyon;

            const sablonMatch =
                !sablonUyeIdSet ||
                sablonUyeIdSet.has(String(p.kullaniciId || p.id));

            return aramaMatch && pozisyonMatch && sablonMatch;
        });
    }, [personeller, arama, pozisyonFiltre, sablonUyeIdSet]);


    const shiftSidebarMenu = [
        {
            key: "planlama",
            label: "Vardiya Planlama",
            icon: CalendarClock,
        },
        {
            key: "gunlukRapor",
            label: "Günlük Rapor",
            icon: ClipboardList,
        },
        {
            key: "puantaj",
            label: "Puantaj",
            icon: FileText,
        },
        {
            key: "personelPanel",
            label: "Personel Panele Dön",
            icon: ArrowLeft,
        },
    ];

    const toplamSayfa = useMemo(() => {
        return Math.max(1, Math.ceil(filtreliPersoneller.length / sayfaBoyutu));
    }, [filtreliPersoneller.length, sayfaBoyutu]);

    const sayfadakiPersoneller = useMemo(() => {
        const baslangicIndex = (sayfa - 1) * sayfaBoyutu;
        const bitisIndex = baslangicIndex + sayfaBoyutu;

        return filtreliPersoneller.slice(baslangicIndex, bitisIndex);
    }, [filtreliPersoneller, sayfa, sayfaBoyutu]);

    const listeBaslangic = filtreliPersoneller.length === 0
        ? 0
        : (sayfa - 1) * sayfaBoyutu + 1;

    const listeBitis = Math.min(
        sayfa * sayfaBoyutu,
        filtreliPersoneller.length
    );


    const [contextOptionsPozisyon, setContextOptionsPozisyon] = useState({
        top: 0,
        left: 0,
        width: 330,
        maxHeight: 520,
    });


    const handleTopluSagTik = (e) => {
        if (aktifShiftSayfa !== "planlama") return;

        const hedef = e.target;

        const tabloAlani =
            hedef.closest(".shift-record-card") ||
            hedef.closest(".shift-table-box") ||
            hedef.closest(".shift-plan-table");

        const menuIcinde = hedef.closest(".shift-options-menu");
        const vardiyaDropdownIcinde = hedef.closest(".shift-cell-dropdown");

        if (!tabloAlani || menuIcinde || vardiyaDropdownIcinde) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        if (seciliPersoneller.length === 0) {
            setApiHata("Önce işlem yapmak istediğin kullanıcıları seçmelisin.");
            return;
        }

        setApiHata("");
        contextOptionsPozisyonHesapla(e.clientX, e.clientY);

        setOptionsOpen(true);
        setDropdownHucre(null);
    };

    const handleHucreSagTik = (e, hucreKey) => {
        e.preventDefault();
        e.stopPropagation();

        contextMenuPozisyonHesapla(e.clientX, e.clientY);

        setDropdownHucre(hucreKey);
        setOptionsOpen(false);
    };

    const tumSeciliMi =
        sayfadakiPersoneller.length > 0 &&
        sayfadakiPersoneller.every((p) => seciliPersoneller.includes(p.id));

    const lokasyonlariGetir = async () => {
        try {
            setVeriYukleniyor(true);
            setApiHata("");

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/lokasyonlar?yetki=vardiya.plan.yonet`,
                {
                    headers: authHeader,
                }
            );

            console.log("Vardiya lokasyonları:", res.data);

            const gelenLokasyonlar = apiArrayGetir(res.data);

            setLokasyonlar(gelenLokasyonlar);

            const siraliListe = lokasyonSelectListesiOlustur(gelenLokasyonlar);

            if (siraliListe.length > 0) {
                setSeciliLokasyonId(String(siraliListe[0].id));
            }
        } catch (error) {
            console.error("Lokasyonlar alınamadı:", error);

            setApiHata(
                error.response?.data?.message ||
                "Lokasyonlar alınamadı."
            );
        } finally {
            setVeriYukleniyor(false);
        }
    };

    const vardiyaSablonunuSecenegeCevir = (sablon) => {
        const baslangic = sablon.baslangicSaati || "";
        const bitis = sablon.bitisSaati || "";

        const saat =
            baslangic && bitis
                ? `${baslangic}-${bitis}`
                : "";

        const tipMap = {
            Calisma: "calisma",
            Izin: "izin",
            Raporlu: "raporlu",
            Bos: "bos",
        };

        return {
            id: `sablon-${sablon.id}`,
            vardiyaSablonId: sablon.id,
            label: sablon.ad || sablon.kod || "Vardiya",
            sure: "",
            saat,
            tip: tipMap[sablon.tip] || "calisma",
            apiTip: sablon.tip || "Calisma",
            molaDakika: sablon.molaDakika,
            etiket: sablon.etiket || null,
            renk: sablon.renk || null,
            ozelVardiyaMi: false,
            ham: sablon,
        };
    };

    const vardiyaSablonlariniGetir = async () => {
        try {
            setApiHata("");

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/sablonlar?sadeceAktif=true`,
                {
                    headers: authHeader,
                }
            );

            console.log("Vardiya şablonları:", res.data);

            const gelenSablonlar = apiArrayGetir(res.data);

            const apiSecenekleri = gelenSablonlar.map(vardiyaSablonunuSecenegeCevir);

            setVardiyaSecenekleri(apiSecenekleri);

        } catch (error) {
            console.error("Vardiya şablonları alınamadı:", error);

            setVardiyaSecenekleri(varsayilanVardiyaSecenekleri);

            setApiHata(
                error.response?.data?.message ||
                "Vardiya şablonları alınamadı."
            );
        }
    };

    const lokasyonAdiGetir = (lokasyonId) => {
        const lokasyon = lokasyonlar.find(
            (item) => String(item.id) === String(lokasyonId)
        );

        return lokasyon?.ad || lokasyon?.gorunenAd || "Tüm lokasyonlar";
    };

    const personelSablonlariniYenile = async (filtre = {}) => {
        const lokasyonId = filtre.lokasyonId ?? seciliLokasyonApiId;

        if (!lokasyonId) {
            setPersonelSablonlari([]);
            return;
        }

        try {
            setPersonelSablonYukleniyor(true);

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/personel-sablonlarim?lokasyonId=${lokasyonId}`,
                { headers: authHeader }
            );

            const gelenSablonlar = apiArrayGetir(res.data).map((sablon) => ({
                id: sablon.id,
                ad: sablon.ad || "",
                lokasyonId: sablon.lokasyonId || "",
                personelSayisi: sablon.personelSayisi ?? apiArrayGetir(sablon.kullaniciIdleri).length,
                kullaniciIdleri: apiArrayGetir(sablon.kullaniciIdleri)
                    .map((id) => String(id))
                    .filter(Boolean),
                personeller: apiArrayGetir(sablon.personeller),
                aktifMi: sablon.aktifMi !== false,
            }));

            setPersonelSablonlari(gelenSablonlar);
        } catch (error) {
            console.error("Personel şablonları alınamadı:", error);
            mesajGoster("Personel şablonları alınamadı.", "error");
        } finally {
            setPersonelSablonYukleniyor(false);
        }
    };


    const personelSablonFormDegistir = (alan, value) => {
        setPersonelSablonForm((prev) => ({
            ...prev,
            [alan]: value,
        }));
    };

    const personelSablonFormTemizle = () => {
        setPersonelSablonForm(yeniPersonelSablonFormu());
        setDuzenlenenPersonelSablonId(null);
    };

    const personelSablonKaydet = async () => {
        const ad = personelSablonForm.ad.trim();
        const lokasyonId = seciliLokasyonApiId;

        if (!ad || !lokasyonId) {
            mesajGoster("Şablon adı zorunlu. Lokasyon seçili mağazadan gelir.", "warning");
            return;
        }

        const payload = {
            ad,
            lokasyonId: Number(lokasyonId),
            aktifMi: personelSablonForm.aktifMi !== false,
        };

        try {
            setPersonelSablonYukleniyor(true);

            if (duzenlenenPersonelSablonId) {
                await axios.put(
                    `${apiBaseUrl}/api/Vardiya/personel-sablonlarim/${duzenlenenPersonelSablonId}`,
                    payload,
                    { headers: authHeader }
                );
            } else {
                await axios.post(
                    `${apiBaseUrl}/api/Vardiya/personel-sablonlarim`,
                    payload,
                    { headers: authHeader }
                );
            }

            personelSablonFormTemizle();
            await personelSablonlariniYenile({ lokasyonId });

            mesajGoster(
                duzenlenenPersonelSablonId
                    ? "Personel şablonu güncellendi."
                    : "Personel şablonu eklendi.",
                "success"
            );
        } catch (error) {
            console.error("Personel şablonu kaydedilemedi:", error);
            mesajGoster(
                error.response?.data?.message || "Personel şablonu kaydedilemedi.",
                "error"
            );
        } finally {
            setPersonelSablonYukleniyor(false);
        }
    };



    const personelSablonDuzenle = (sablon) => {
        setDuzenlenenPersonelSablonId(sablon.id);

        setPersonelSablonForm({
            ad: sablon.ad || "",
            aktifMi: sablon.aktifMi !== false,
        });

        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const personelSablonSilIste = (sablon) => {
        setSilinecekPersonelSablon(sablon);
    };

    const personelSablonSilOnayla = async () => {
        if (!silinecekPersonelSablon?.id) return;

        try {
            setPersonelSablonYukleniyor(true);

            const token = localStorage.getItem("token");

            const res = await fetch(
                `https://api.fulla.com.tr/api/Vardiya/personel-sablonlarim/${silinecekPersonelSablon.id}`,
                {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (!res.ok) {
                throw new Error("Şablon silinemedi.");
            }

            setSilinecekPersonelSablon(null);
            personelSablonFormTemizle();
            await personelSablonlariniYenile();
        } catch (error) {
            console.error("Personel şablonu silinirken hata:", error);
            alert("Şablon silinirken bir hata oluştu.");
        } finally {
            setPersonelSablonYukleniyor(false);
        }
    };

    const getVardiya = (id) => {
        if (!id) return null;

        return vardiyaSecenekleri.find((x) => String(x.id) === String(id)) || null;
    };

    const getVardiyaHucreStyle = (vardiya) => {
        if (!vardiya) return {};

        const label = (vardiya.label || "").toLocaleUpperCase("tr-TR");
        const tip = (vardiya.tip || "").toLowerCase();
        const apiTip = (vardiya.apiTip || "").toLowerCase();

        // Rapor
        if (tip === "raporlu" || apiTip === "raporlu" || label.includes("RAPOR")) {
            return {
                backgroundColor: "#ffedd5",
                borderColor: "#fb923c",
                color: "#9a3412",
            };
        }

        // Boş gün
        if (tip === "bos" || apiTip === "bos" || label.includes("BOŞ")) {
            return {
                backgroundColor: "#e5e7eb",
                borderColor: "#9ca3af",
                color: "#374151",
            };
        }

        // Yarım çalışma
        if (label.includes("YÇ") || label.includes("YARIM ÇALIŞMA")) {
            return {
                backgroundColor: "#e0f2fe",
                borderColor: "#38bdf8",
                color: "#075985",
            };
        }

        // Bayram / yıllık izin
        if (
            label.includes("BAYRAM") ||
            label.includes("Yİ") ||
            label.includes("YILLIK")
        ) {
            return {
                backgroundColor: "#dcfce7",
                borderColor: "#22c55e",
                color: "#166534",
            };
        }

        // Haftalık izin
        if (label.includes("Hİ") || label.includes("HAFTALIK")) {
            return {
                backgroundColor: "#ede9fe",
                borderColor: "#8b5cf6",
                color: "#5b21b6",
            };
        }

        // Özel izinler: ölüm, doğum, evlilik, mazeret
        if (
            label.includes("ÖLÜM") ||
            label.includes("DOĞUM") ||
            label.includes("EVLİLİK") ||
            label.includes("MAZERET") ||
            label.includes("ÜCRETSİZ") ||
            label.includes("İZİN")
        ) {
            return {
                backgroundColor: "#ffe4e6",
                borderColor: "#fb7185",
                color: "#9f1239",
            };
        }

        // Normal çalışma
        return {
            backgroundColor: "#dbeafe",
            borderColor: "#60a5fa",
            color: "#0f172a",
        };
    };

    const mesajGoster = (mesaj, tip = "success") => {
        if (bildirimTimerRef.current) {
            clearTimeout(bildirimTimerRef.current);
        }

        setBildirim({
            acik: true,
            tip,
            mesaj,
        });

        bildirimTimerRef.current = setTimeout(() => {
            setBildirim({
                acik: false,
                tip: "success",
                mesaj: "",
            });
        }, 3000);
    };

    const bildirimKapat = () => {
        if (bildirimTimerRef.current) {
            clearTimeout(bildirimTimerRef.current);
        }

        setBildirim({
            acik: false,
            tip: "success",
            mesaj: "",
        });
    };

    const kayitKullaniciIdGetir = (kayit = {}) => {
        return (
            kayit.kullaniciId ||
            kayit.kullaniciID ||
            kayit.userId ||
            kayit.userID ||
            kayit.personelId ||
            kayit.personelID ||
            kayit.id ||
            ""
        );
    };

    const kayitAdSoyadGetir = (kayit = {}) => {
        return (
            kayit.adSoyad ||
            kayit.adSoyadFull ||
            kayit.fullName ||
            kayit.name ||
            kayit.kullaniciAdi ||
            `${kayit.ad || ""} ${kayit.soyad || ""}`.trim() ||
            "-"
        );
    };

    const metinNormalize = (metin = "") => {
        return String(metin)
            .trim()
            .toLocaleLowerCase("tr-TR")
            .replace(/\s+/g, " ");
    };


    const saatKisalt = (value) => {
        if (!value) return "";

        return String(value).substring(0, 5);
    };

    const ozelVardiyaIdOlustur = ({
        kullaniciId,
        tarih,
        baslangicSaati,
        bitisSaati,
        molaDakika,
    }) => {
        const temizle = (value) =>
            String(value ?? "")
                .replace(/[^a-zA-Z0-9]/g, "")
                .trim();

        return `ozel-${temizle(kullaniciId)}-${temizle(tarih)}-${temizle(baslangicSaati)}-${temizle(bitisSaati)}-${temizle(molaDakika)}`;
    };

    const ozelVardiyaSecenegiOlustur = ({
        id,
        baslangicSaati,
        bitisSaati,
        molaDakika,
        aciklama,
    }) => {
        const mola =
            molaDakika !== null &&
                molaDakika !== undefined &&
                molaDakika !== ""
                ? Number(molaDakika)
                : null;

        return {
            id,
            vardiyaSablonId: null,
            label: "Özel Vardiya",
            sure: "",
            saat: `${saatKisalt(baslangicSaati)}-${saatKisalt(bitisSaati)}`,
            tip: "calisma",
            apiTip: "Calisma",
            molaDakika: Number.isNaN(mola) ? null : mola,
            etiket: "Özel Vardiya",
            aciklama: aciklama || null,
            ozelVardiyaMi: true,
        };
    };

    const gunuVardiyaIdyeCevir = (gunKaydi, kullaniciId = "", tarihKey = "") => {
        if (!gunKaydi) return "";

        const vardiyaSablonId =
            gunKaydi.vardiyaSablonId ||
            gunKaydi.vardiyaSablonID ||
            gunKaydi.sablonId ||
            gunKaydi.sablonID ||
            null;

        if (vardiyaSablonId) {
            return `sablon-${vardiyaSablonId}`;
        }

        const baslangicSaati = saatKisalt(
            gunKaydi.baslangicSaati ||
            gunKaydi.vardiyaBaslangicSaati ||
            gunKaydi.girisSaati
        );

        const bitisSaati = saatKisalt(
            gunKaydi.bitisSaati ||
            gunKaydi.vardiyaBitisSaati ||
            gunKaydi.cikisSaati
        );

        if (baslangicSaati && bitisSaati) {
            return ozelVardiyaIdOlustur({
                kullaniciId,
                tarih: tarihKey,
                baslangicSaati,
                bitisSaati,
                molaDakika: gunKaydi.molaDakika ?? gunKaydi.molaSuresiDakika ?? "",
            });
        }

        return "";
    };

    const apiPlanKaydiniPersonelFormatinaCevir = (
        kayitlar = [],
        tarihListesi = haftaTarihleri
    ) => {
        const ozelSecenekler = [];

        const personelListesi = apiArrayGetir(kayitlar)
            .filter(Boolean)
            .map((kayit) => {
                const kullaniciId = kayitKullaniciIdGetir(kayit);
                const adSoyad = kayitAdSoyadGetir(kayit);

                const gunKayitlari = apiArrayGetir(kayit.gunler)
                    .filter((gun) => gun && gun.tarih);

                const shiftler = tarihListesi.map((tarih) => {
                    const tarihKey = formatDateForApi(tarih);

                    const gunKaydi = gunKayitlari.find((gun) => {
                        const gunTarihKey = String(gun.tarih).substring(0, 10);
                        return gunTarihKey === tarihKey;
                    });

                    const vardiyaId = gunuVardiyaIdyeCevir(
                        gunKaydi,
                        kullaniciId,
                        tarihKey
                    );

                    if (vardiyaId && String(vardiyaId).startsWith("ozel-")) {
                        const baslangicSaati = saatKisalt(
                            gunKaydi.baslangicSaati ||
                            gunKaydi.vardiyaBaslangicSaati ||
                            gunKaydi.girisSaati
                        );

                        const bitisSaati = saatKisalt(
                            gunKaydi.bitisSaati ||
                            gunKaydi.vardiyaBitisSaati ||
                            gunKaydi.cikisSaati
                        );

                        ozelSecenekler.push(
                            ozelVardiyaSecenegiOlustur({
                                id: vardiyaId,
                                baslangicSaati,
                                bitisSaati,
                                molaDakika:
                                    gunKaydi.molaDakika ??
                                    gunKaydi.molaSuresiDakika ??
                                    "",
                                aciklama:
                                    gunKaydi.aciklama ||
                                    gunKaydi.durumAciklama ||
                                    "",
                            })
                        );
                    }

                    return vardiyaId;
                });

                return {
                    id: String(kullaniciId || adSoyad),
                    kullaniciId: kullaniciId ? String(kullaniciId) : "",
                    ad: adSoyad,
                    pozisyon: kayit.pozisyon || kayit.pozisyonAdi || "-",
                    etiket:
                        kayit.grupAdi ||
                        kayit.etiket ||
                        kayit.lokasyonAdi ||
                        "",
                    avatar: getAvatarText(adSoyad),
                    foto: kayit.foto || kayit.fotoUrl || kayit.profilePhotoUrl || kayit.profilFotoUrl || "",
                    profilFotoUrl: kayit.profilFotoUrl || "",
                    profilFotoEndpoint: kayit.profilFotoEndpoint || "",
                    shiftler,
                };
            });

        if (ozelSecenekler.length > 0) {
            setVardiyaSecenekleri((prev) => {
                const map = new Map();

                prev.forEach((item) => {
                    map.set(String(item.id), item);
                });

                ozelSecenekler.forEach((item) => {
                    map.set(String(item.id), item);
                });

                return Array.from(map.values());
            });
        }

        return personelListesi;
    };

    const kullanicilariGetir = async (signal) => {
        if (!seciliLokasyonId) return;

        try {
            setVeriYukleniyor(true);
            setApiHata("");

            const params = new URLSearchParams();

            params.append("lokasyonId", seciliLokasyonId);

            if (arama.trim()) {
                params.append("ara", arama.trim());
            }

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/kullanicilar?${params.toString()}`,
                {
                    signal,
                    headers: authHeader,
                }
            );

            if (signal?.aborted) return;

            const gelenKullanicilar = apiArrayGetir(res.data);
            const formatliPersoneller =
                kullanicilariPersonelFormatinaCevir(gelenKullanicilar);

            const kayitli = localStorage.getItem(haftaKey);

            if (kayitli) {
                try {
                    const kayitliPersoneller = JSON.parse(kayitli);

                    const haftayaGorePersoneller = formatliPersoneller.map((personel) => {
                        const kayitliPersonel = kayitliPersoneller.find(
                            (x) => String(x.id) === String(personel.id)
                        );

                        return {
                            ...personel,
                            shiftler: kayitliPersonel?.shiftler || bosShiftler(),
                        };
                    });

                    setPersoneller(haftayaGorePersoneller);
                } catch {
                    setPersoneller(formatliPersoneller);
                }
            } else {
                setPersoneller(formatliPersoneller);
            }

            setSeciliPersoneller([]);
        } catch (error) {
            if (signal?.aborted) return;
            console.error("Kullanıcılar alınamadı:", error);

            setPersoneller([]);

            setApiHata(
                error.response?.data?.message ||
                "Kullanıcılar alınamadı."
            );
        } finally {
            if (!signal?.aborted) setVeriYukleniyor(false);
        }
    };

    const bosShiftler = () => ["", "", "", "", "", "", ""];

    const personelleriKopyala = (liste = personeller) => {
        return liste.map((personel) => ({
            ...personel,
            shiftler: Array.isArray(personel.shiftler)
                ? [...personel.shiftler]
                : bosShiftler(),
        }));
    };

    const geriAlKaydiEkle = () => {
        setUndoGecmisi((prev) => {
            const yeniGecmis = [...prev, personelleriKopyala(personeller)];

            // Çok şişmesin diye son 20 işlemi tutuyoruz
            return yeniGecmis.slice(-20);
        });
    };

    const sonDegisikligiGeriAl = () => {
        if (undoGecmisi.length === 0) return;

        const sonKayit = undoGecmisi[undoGecmisi.length - 1];
        const kalanGecmis = undoGecmisi.slice(0, -1);

        setPersoneller(personelleriKopyala(sonKayit));
        setUndoGecmisi(kalanGecmis);

        localStorage.setItem(haftaKey, JSON.stringify(sonKayit));

        setDropdownHucre(null);
        setOptionsOpen(false);

        mesajGoster("Son değişiklik geri alındı.", "warning");
    };



    const apiTipGetir = (vardiyaTip) => {
        if (vardiyaTip === "izin") return "Izin";
        if (vardiyaTip === "raporlu") return "Raporlu";
        if (vardiyaTip === "bos") return "Bos";

        return "Calisma";
    };

    const saatleriAyir = (saat = "") => {
        if (!saat || !saat.includes("-")) {
            return {
                baslangicSaati: null,
                bitisSaati: null,
            };
        }

        const [baslangicSaati, bitisSaati] = saat.split("-");

        return {
            baslangicSaati: baslangicSaati || null,
            bitisSaati: bitisSaati || null,
        };
    };

    const saatDakikaToDakika = (saat) => {
        if (!saat) return 0;

        const [hour, minute] = String(saat).split(":").map(Number);

        if (Number.isNaN(hour) || Number.isNaN(minute)) {
            return 0;
        }

        return hour * 60 + minute;
    };

    const dakikaToSaatYazi = (dakika) => {
        if (!dakika) return "";

        const saat = Math.floor(dakika / 60);
        const kalanDakika = dakika % 60;

        if (kalanDakika === 0) {
            return `${saat}s`;
        }

        return `${saat}s ${kalanDakika}dk`;
    };

    const vardiyaNetDakikaHesapla = (vardiya) => {
        if (!vardiya?.saat || !vardiya.saat.includes("-")) return 0;

        const { baslangicSaati, bitisSaati } = saatleriAyir(vardiya.saat);

        if (!baslangicSaati || !bitisSaati) return 0;

        const baslangicDakika = saatDakikaToDakika(baslangicSaati);
        const bitisDakika = saatDakikaToDakika(bitisSaati);

        const toplamDakika =
            bitisDakika >= baslangicDakika
                ? bitisDakika - baslangicDakika
                : 24 * 60 - baslangicDakika + bitisDakika;

        const molaDakika =
            vardiya.molaDakika !== null &&
                vardiya.molaDakika !== undefined &&
                vardiya.molaDakika !== ""
                ? Number(vardiya.molaDakika)
                : 0;

        const netDakika = toplamDakika - (Number.isNaN(molaDakika) ? 0 : molaDakika);

        return Math.max(netDakika, 0);
    };

    const vardiyaToplamSureYazi = (vardiya) => {
        return dakikaToSaatYazi(vardiyaNetDakikaHesapla(vardiya));
    };
    const personelHaftalikToplamDakika = (personel) => {
        if (!personel?.shiftler || !Array.isArray(personel.shiftler)) return 0;

        return personel.shiftler.reduce((toplam, vardiyaId) => {
            const vardiya = getVardiya(vardiyaId);

            if (!vardiya || vardiya.tip !== "calisma") {
                return toplam;
            }
            return toplam + vardiyaNetDakikaHesapla(vardiya);
        }, 0);
    };

    const personelHaftalikToplamYazi = (personel) => {
        const toplamDakika = personelHaftalikToplamDakika(personel);

        if (!toplamDakika) {
            return "0s / 45s";
        }

        return `${dakikaToSaatYazi(toplamDakika)} / 45s`;
    };

    const personelHaftalikToplamClass = (personel) => {
        const toplamDakika = personelHaftalikToplamDakika(personel);
        const hedefDakika = 45 * 60;

        if (toplamDakika === hedefDakika) {
            return "tam";
        }

        if (toplamDakika > hedefDakika) {
            return "fazla";
        }

        return "eksik";
    };

    const planGetir = async () => {
        if (!seciliLokasyonId) return;
        planRequestRef.current?.abort();
        const controller = new AbortController();
        planRequestRef.current = controller;

        try {
            setVeriYukleniyor(true);
            setApiHata("");

            const params = new URLSearchParams();

            params.append("baslangicTarihi", formatDateForApi(haftaTarihleri[0]));
            params.append("bitisTarihi", formatDateForApi(haftaTarihleri[6]));
            params.append("lokasyonId", seciliLokasyonId);

            if (arama.trim()) {
                params.append("ara", arama.trim());
            }

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/plan?${params.toString()}`,
                {
                    signal: controller.signal,
                    headers: authHeader,
                }
            );

            if (controller.signal.aborted) return;

            const plan = res.data?.data || res.data;
            const kayitlar = apiArrayGetir(plan?.kayitlar).filter(Boolean);

            if (kayitlar.length === 0) {
                await kullanicilariGetir(controller.signal);
                return;
            }

            const formatliPersoneller =
                apiPlanKaydiniPersonelFormatinaCevir(kayitlar);

            setPersoneller(formatliPersoneller);
            setSeciliPersoneller([]);
            setDropdownHucre(null);
            setOptionsOpen(false);

            localStorage.setItem(haftaKey, JSON.stringify(formatliPersoneller));
        } catch (error) {
            if (controller.signal.aborted) return;
            console.error("Vardiya planı alınamadı:", error);

            setPersoneller([]);

            setApiHata(
                error.response?.data?.message ||
                "Vardiya planı alınamadı."
            );
        } finally {
            if (!controller.signal.aborted) setVeriYukleniyor(false);
        }
    };

    const mevcutApiPlaniniGetir = async () => {
        if (!seciliLokasyonId) return null;

        const params = new URLSearchParams();

        params.append("baslangicTarihi", formatDateForApi(haftaTarihleri[0]));
        params.append("bitisTarihi", formatDateForApi(haftaTarihleri[6]));
        params.append("lokasyonId", seciliLokasyonId);

        const res = await axios.get(
            `${apiBaseUrl}/api/Vardiya/plan?${params.toString()}`,
            {
                headers: authHeader,
            }
        );

        return res.data?.data || res.data;
    };

    const silinecekPlanIdleriGetir = async () => {
        const mevcutPlan = await mevcutApiPlaniniGetir();

        if (!mevcutPlan) return [];

        const kayitlar = apiArrayGetir(mevcutPlan.kayitlar);
        const apiPlanMap = new Map();

        kayitlar.forEach((kayit) => {
            const gunler = apiArrayGetir(kayit.gunler);
            gunler.forEach((gun) => {
                if (!gun?.id || !gun?.tarih) return;

                const tarihKey = String(gun.tarih).substring(0, 10);
                const mapKey = `${String(kayit.kullaniciId)}-${tarihKey}`;

                apiPlanMap.set(mapKey, gun.id);
            });
        });

        const silinecekPlanIds = [];

        personeller.forEach((personel) => {
            personel.shiftler.forEach((vardiyaId, gunIndex) => {
                if (vardiyaId) return;

                const tarihKey = formatDateForApi(haftaTarihleri[gunIndex]);
                const mapKey = `${String(personel.kullaniciId || personel.id)}-${tarihKey}`;
                const planId = apiPlanMap.get(mapKey);

                if (planId) {
                    silinecekPlanIds.push(planId);
                }
            });
        });

        return silinecekPlanIds;
    };

    const apiAtamalariHazirla = () => {
        const atamalar = [];

        personeller.forEach((personel) => {
            personel.shiftler.forEach((vardiyaId, gunIndex) => {
                const vardiya = getVardiya(vardiyaId);

                if (!vardiya) return;

                const { baslangicSaati, bitisSaati } = saatleriAyir(vardiya.saat);
                const vardiyaSablonId = vardiya.vardiyaSablonId || null;

                atamalar.push({
                    kullaniciId: personel.kullaniciId || personel.id,
                    tarih: formatDateForApi(haftaTarihleri[gunIndex]),
                    vardiyaSablonId: vardiyaSablonId,
                    tip: vardiya.apiTip || apiTipGetir(vardiya.tip),
                    baslangicSaati: vardiyaSablonId ? null : baslangicSaati,
                    bitisSaati: vardiyaSablonId ? null : bitisSaati,
                    molaDakika: vardiyaSablonId
                        ? null
                        : vardiya.tip === "izin"
                            ? null
                            : vardiya.molaDakika !== null &&
                                vardiya.molaDakika !== undefined &&
                                vardiya.molaDakika !== ""
                                ? Number(vardiya.molaDakika)
                                : null,
                    etiket: vardiyaSablonId ? null : vardiya.etiket || personel.etiket || null,
                    aciklama: vardiyaSablonId ? null : vardiya.aciklama || null,
                    ozelVardiyaMi: !vardiyaSablonId,
                });
            });
        });

        return atamalar;
    };

    const haftayiSessizKaydet = () => {
        if (personeller.length === 0) return;

        localStorage.setItem(haftaKey, JSON.stringify(personeller));
    };

    const kaydet = async () => {
        if (!seciliLokasyonId) {
            setApiHata("Kaydetmek için önce lokasyon seçmelisin.");
            return;
        }

        try {
            setVeriYukleniyor(true);
            setApiHata("");

            const atamalar = apiAtamalariHazirla();
            const silinecekPlanIds = await silinecekPlanIdleriGetir();

            if (silinecekPlanIds.length > 0) {
                await axios.post(
                    `${apiBaseUrl}/api/Vardiya/plan/sil`,
                    {
                        planIds: silinecekPlanIds,
                    },
                    {
                        headers: authHeader,
                    }
                );
            }

            if (atamalar.length > 0) {
                const payload = {
                    baslangicTarihi: formatDateForApi(haftaTarihleri[0]),
                    bitisTarihi: formatDateForApi(haftaTarihleri[6]),
                    lokasyonId: Number(seciliLokasyonId),
                    atamalar,
                };

                console.log("Vardiya kaydet payload:", payload);

                await axios.post(
                    `${apiBaseUrl}/api/Vardiya/plan`,
                    payload,
                    {
                        headers: authHeader,
                    }
                );
            }

            localStorage.setItem(haftaKey, JSON.stringify(personeller));

            setDropdownHucre(null);
            setOptionsOpen(false);

            await planGetir();

            setUndoGecmisi([]);

            mesajGoster("Vardiya planı başarıyla kaydedildi.", "success");
        } catch (error) {
            console.error("Vardiya planı kaydedilemedi:", error);
            console.error("Vardiya planı API hata detayı:", error.response?.data);

            const apiHata = error.response?.data;
            const hataReferansi = apiHata?.hataId
                ? ` (Hata referansı: ${apiHata.hataId})`
                : "";

            setApiHata(
                `${apiHata?.message || "Vardiya planı kaydedilemedi."}${hataReferansi}`
            );
        } finally {
            setVeriYukleniyor(false);
        }
    };

    const haftaDegistir = (yon) => {
        haftayiSessizKaydet();

        const yeniHafta = getMonday(
            addDays(haftaBaslangic, yon === "ileri" ? 7 : -7)
        );

        setHaftaBaslangic(yeniHafta);
        setDropdownHucre(null);
        setOptionsOpen(false);
    };

    const tarihSecildi = (e) => {
        const secilenTarih = e.target.value;

        if (!secilenTarih) return;
        haftayiSessizKaydet();

        const tarih = new Date(`${secilenTarih}T00:00:00`);

        setHaftaBaslangic(getMonday(tarih));
        setDropdownHucre(null);
        setOptionsOpen(false);
    };

    const buHaftayaDon = () => {
        haftayiSessizKaydet();

        setHaftaBaslangic(getMonday(new Date()));
        setDropdownHucre(null);
        setOptionsOpen(false);
    };

    const gecenHaftayiKopyala = async () => {
        if (!seciliLokasyonId) {
            mesajGoster("Önce lokasyon seçmelisin.", "warning");
            setOptionsOpen(false);
            return;
        }

        try {
            setVeriYukleniyor(true);
            setApiHata("");

            const oncekiHaftaBaslangic = getMonday(addDays(haftaBaslangic, -7));

            const oncekiHaftaTarihleri = gunler.map((_, index) =>
                addDays(oncekiHaftaBaslangic, index)
            );

            const params = new URLSearchParams();

            params.append("baslangicTarihi", formatDateForApi(oncekiHaftaTarihleri[0]));
            params.append("bitisTarihi", formatDateForApi(oncekiHaftaTarihleri[6]));
            params.append("lokasyonId", seciliLokasyonId);

            const res = await axios.get(
                `${apiBaseUrl}/api/Vardiya/plan?${params.toString()}`,
                {
                    headers: authHeader,
                }
            );

            console.log("Geçen hafta vardiya planı:", res.data);

            const plan = res.data?.data || res.data;
            const kayitlar = apiArrayGetir(plan?.kayitlar).filter(Boolean);

            if (kayitlar.length === 0) {
                mesajGoster("Geçen haftaya ait kayıt bulunamadı.", "warning");
                setOptionsOpen(false);
                return;
            }

            const oncekiHaftaPersoneller = apiPlanKaydiniPersonelFormatinaCevir(
                kayitlar,
                oncekiHaftaTarihleri
            );

            if (oncekiHaftaPersoneller.length === 0) {
                mesajGoster("Geçen haftaya ait kullanılabilir vardiya bulunamadı.", "warning");
                setOptionsOpen(false);
                return;
            }

            const oncekiIdMap = new Map();
            const oncekiAdMap = new Map();

            oncekiHaftaPersoneller.forEach((p) => {
                if (p.kullaniciId) {
                    oncekiIdMap.set(String(p.kullaniciId), p.shiftler);
                }

                oncekiAdMap.set(metinNormalize(p.ad), p.shiftler);
            });

            if (personeller.length === 0) {
                geriAlKaydiEkle();

                setPersoneller(oncekiHaftaPersoneller);
                localStorage.setItem(haftaKey, JSON.stringify(oncekiHaftaPersoneller));

                setOptionsOpen(false);
                mesajGoster("Geçen haftanın vardiyaları bu haftaya kopyalandı.", "success");
                return;
            }

            let kopyalananKisiSayisi = 0;

            const yeniPersoneller = personeller.map((personel) => {
                const kullaniciId = String(personel.kullaniciId || personel.id || "");
                const adKey = metinNormalize(personel.ad);

                const oncekiShiftler =
                    oncekiIdMap.get(kullaniciId) ||
                    oncekiAdMap.get(adKey);

                if (!oncekiShiftler) {
                    return personel;
                }

                kopyalananKisiSayisi += 1;

                return {
                    ...personel,
                    shiftler: [...oncekiShiftler],
                };
            });

            if (kopyalananKisiSayisi === 0) {
                geriAlKaydiEkle();

                setPersoneller(oncekiHaftaPersoneller);
                localStorage.setItem(haftaKey, JSON.stringify(oncekiHaftaPersoneller));

                setOptionsOpen(false);
                mesajGoster("Geçen haftadaki personeller bu haftaya aktarıldı.", "success");
                return;
            }

            geriAlKaydiEkle();

            setPersoneller(yeniPersoneller);
            localStorage.setItem(haftaKey, JSON.stringify(yeniPersoneller));

            setOptionsOpen(false);
            mesajGoster("Geçen haftanın vardiyaları bu haftaya kopyalandı.", "success");
        } catch (error) {
            console.error("Geçen hafta vardiyaları kopyalanamadı:", error);

            setApiHata(
                error.response?.data?.message ||
                "Geçen hafta vardiyaları kopyalanamadı."
            );

            mesajGoster("Geçen hafta vardiyaları kopyalanamadı.", "error");
        } finally {
            setVeriYukleniyor(false);
        }
    };

    const oncekiSayfa = () => {
        setSayfa((prev) => Math.max(1, prev - 1));
    };

    const sonrakiSayfa = () => {
        setSayfa((prev) => Math.min(toplamSayfa, prev + 1));
    };

    const sayfaBoyutuDegistir = (e) => {
        setSayfaBoyutu(Number(e.target.value));
    };

    const toggleTumSec = () => {
        const sayfadakiIds = sayfadakiPersoneller.map((p) => p.id);

        if (tumSeciliMi) {
            setSeciliPersoneller((prev) =>
                prev.filter((id) => !sayfadakiIds.includes(id))
            );
            return;
        }

        setSeciliPersoneller((prev) => {
            const yeniListe = [...prev];

            sayfadakiIds.forEach((id) => {
                if (!yeniListe.includes(id)) {
                    yeniListe.push(id);
                }
            });

            return yeniListe;
        });
    };

    const togglePersonel = (id) => {
        setSeciliPersoneller((prev) => {
            if (prev.includes(id)) {
                return prev.filter((x) => x !== id);
            }

            return [...prev, id];
        });
    };

    const personelReyonSablonDegistir = async (personelId, yeniSablonId) => {
        const personel = personeller.find(
            (item) => String(item.id) === String(personelId)
        );

        if (!personel) return;

        const kullaniciId = String(personel.kullaniciId || personel.id || "");
        const eskiSablonId = personelReyonSablonIdGetir(personel);

        if (!kullaniciId || String(eskiSablonId) === String(yeniSablonId)) return;

        const oncekiPersoneller = personeller;
        const oncekiSablonlar = personelSablonlari;

        const yeniSablonlar = personelSablonlari.map((sablon) => {
            let kullaniciIdleri = apiArrayGetir(sablon.kullaniciIdleri)
                .map((id) => String(id))
                .filter(Boolean)
                .filter((id) => id !== kullaniciId);

            if (yeniSablonId && String(sablon.id) === String(yeniSablonId)) {
                kullaniciIdleri = [...kullaniciIdleri, kullaniciId];
            }

            return {
                ...sablon,
                kullaniciIdleri,
                personelSayisi: kullaniciIdleri.length,
            };
        });

        const yeniPersoneller = personeller.map((item) =>
            String(item.id) === String(personelId)
                ? {
                    ...item,
                    reyonSablonId: yeniSablonId,
                    personelSablonId: yeniSablonId,
                }
                : item
        );

        setPersoneller(yeniPersoneller);
        setPersonelSablonlari(yeniSablonlar);
        localStorage.setItem(haftaKey, JSON.stringify(yeniPersoneller));

        const guncellenecekSablonIdleri = [
            eskiSablonId,
            yeniSablonId,
        ].filter(Boolean);

        const tekilSablonIdleri = [...new Set(guncellenecekSablonIdleri.map(String))];

        try {
            setKaydedilenReyonPersonelId(personelId);

            await Promise.all(
                tekilSablonIdleri.map((sablonId) => {
                    const sablon = yeniSablonlar.find(
                        (item) => String(item.id) === String(sablonId)
                    );

                    if (!sablon) return Promise.resolve();

                    return axios.put(
                        `${apiBaseUrl}/api/Vardiya/personel-sablonlarim/${sablon.id}`,
                        {
                            ad: sablon.ad,
                            lokasyonId: Number(sablon.lokasyonId || seciliLokasyonApiId),
                            kullaniciIdleri: sablon.kullaniciIdleri,
                            aktifMi: sablon.aktifMi !== false,
                        },
                        {
                            headers: authHeader,
                        }
                    );
                })
            );

            mesajGoster("Personelin reyon şablonu kaydedildi.", "success");
        } catch (error) {
            console.error("Personel reyon şablonu kaydedilemedi:", error);

            setPersoneller(oncekiPersoneller);
            setPersonelSablonlari(oncekiSablonlar);
            localStorage.setItem(haftaKey, JSON.stringify(oncekiPersoneller));

            mesajGoster(
                error.response?.data?.message ||
                "Personelin reyon şablonu kaydedilemedi.",
                "error"
            );
        } finally {
            setKaydedilenReyonPersonelId(null);
        }
    };

    const vardiyaAta = (personelId, gunIndex, vardiyaId) => {
        geriAlKaydiEkle();

        setPersoneller((prev) =>
            prev.map((p) => {
                if (p.id !== personelId) return p;

                const yeniShiftler = [...p.shiftler];
                yeniShiftler[gunIndex] = vardiyaId;

                return {
                    ...p,
                    shiftler: yeniShiftler,
                };
            })
        );

        setDropdownHucre(null);
    };

    const ozelVardiyaModalAc = (personelId, gunIndex) => {
        const personel = personeller.find((p) => String(p.id) === String(personelId));
        const mevcutVardiyaId = personel?.shiftler?.[gunIndex];
        const mevcutVardiya = getVardiya(mevcutVardiyaId);

        const saatParcalari = String(mevcutVardiya?.saat || "").split("-");

        setOzelVardiyaModal({
            acik: true,
            personelId,
            gunIndex,
            baslangicSaati: saatKisalt(saatParcalari[0]) || "09:00",
            bitisSaati: saatKisalt(saatParcalari[1]) || "18:00",
            molaDakika:
                mevcutVardiya?.molaDakika !== null &&
                    mevcutVardiya?.molaDakika !== undefined
                    ? String(mevcutVardiya.molaDakika)
                    : "",
            aciklama: mevcutVardiya?.aciklama || "",
        });

        setDropdownHucre(null);
        setOptionsOpen(false);
    };

    const ozelVardiyaModalKapat = () => {
        setOzelVardiyaModal({
            acik: false,
            personelId: "",
            gunIndex: null,
            baslangicSaati: "09:00",
            bitisSaati: "18:00",
            molaDakika: "",
            aciklama: "",
        });
    };

    const ozelVardiyaKaydet = () => {
        const {
            personelId,
            gunIndex,
            baslangicSaati,
            bitisSaati,
            molaDakika,
            aciklama,
        } = ozelVardiyaModal;

        if (!personelId || gunIndex === null || gunIndex === undefined) {
            mesajGoster("Özel vardiya atanacak hücre bulunamadı.", "error");
            return;
        }

        if (!baslangicSaati || !bitisSaati) {
            mesajGoster("Başlangıç ve bitiş saati girmelisin.", "warning");
            return;
        }

        const mola =
            molaDakika !== null &&
                molaDakika !== undefined &&
                molaDakika !== ""
                ? Number(molaDakika)
                : null;

        if (mola !== null && Number.isNaN(mola)) {
            mesajGoster("Mola süresi sayı olmalı.", "warning");
            return;
        }

        const personel = personeller.find((p) => String(p.id) === String(personelId));

        if (!personel) {
            mesajGoster("Personel bulunamadı.", "error");
            return;
        }

        const tarihKey = formatDateForApi(haftaTarihleri[gunIndex]);

        const ozelVardiyaId = ozelVardiyaIdOlustur({
            kullaniciId: personel.kullaniciId || personel.id,
            tarih: tarihKey,
            baslangicSaati,
            bitisSaati,
            molaDakika: mola ?? "",
        });

        const yeniSecenek = ozelVardiyaSecenegiOlustur({
            id: ozelVardiyaId,
            baslangicSaati,
            bitisSaati,
            molaDakika: mola,
            aciklama,
        });

        setVardiyaSecenekleri((prev) => {
            const map = new Map();

            prev.forEach((item) => {
                map.set(String(item.id), item);
            });

            map.set(String(yeniSecenek.id), yeniSecenek);

            return Array.from(map.values());
        });

        geriAlKaydiEkle();

        setPersoneller((prev) =>
            prev.map((p) => {
                if (String(p.id) !== String(personelId)) return p;

                const yeniShiftler = [...p.shiftler];
                yeniShiftler[gunIndex] = ozelVardiyaId;

                return {
                    ...p,
                    shiftler: yeniShiftler,
                };
            })
        );

        ozelVardiyaModalKapat();
        mesajGoster("Özel vardiya hücreye eklendi.", "success");
    };


    const dropdownPozisyonHesapla = (buttonEl) => {
        if (!buttonEl) return;

        const rect = buttonEl.getBoundingClientRect();

        const bosluk = 12;
        const ekranBosluk = 16;

        const maxDropdownWidth = 360;
        const minDropdownWidth = 280;
        const maxDropdownHeight = Math.min(520, window.innerHeight - ekranBosluk * 2);

        const sagBosluk = window.innerWidth - rect.right - bosluk - ekranBosluk;
        const solBosluk = rect.left - bosluk - ekranBosluk;

        let left;
        let width;

        // Önce sağ tarafı dene
        if (sagBosluk >= minDropdownWidth) {
            width = Math.min(maxDropdownWidth, sagBosluk);
            left = rect.right + bosluk;
        }
        // Sağda yer yoksa sola aç
        else if (solBosluk >= minDropdownWidth) {
            width = Math.min(maxDropdownWidth, solBosluk);
            left = rect.left - width - bosluk;
        }
        // İki tarafta da tam yer yoksa hangi taraf genişse oraya sığdır
        else if (sagBosluk >= solBosluk) {
            width = Math.max(220, sagBosluk);
            left = rect.right + bosluk;
        } else {
            width = Math.max(220, solBosluk);
            left = rect.left - width - bosluk;
        }

        let top = rect.top;

        if (top + maxDropdownHeight > window.innerHeight - ekranBosluk) {
            top = window.innerHeight - maxDropdownHeight - ekranBosluk;
        }

        if (top < ekranBosluk) {
            top = ekranBosluk;
        }

        setDropdownPozisyon({
            top,
            left,
            width,
            maxHeight: maxDropdownHeight,
        });
    };

    const contextMenuPozisyonHesapla = (clientX, clientY) => {
        const bosluk = 12;
        const ekranBosluk = 16;

        const maxDropdownWidth = 360;
        const minDropdownWidth = 280;
        const maxDropdownHeight = Math.min(520, window.innerHeight - ekranBosluk * 2);

        let width = Math.min(maxDropdownWidth, window.innerWidth - ekranBosluk * 2);
        let left = clientX + bosluk;

        if (left + width > window.innerWidth - ekranBosluk) {
            left = clientX - width - bosluk;
        }

        if (left < ekranBosluk) {
            left = ekranBosluk;
            width = window.innerWidth - ekranBosluk * 2;
        }

        let top = clientY;

        if (top + maxDropdownHeight > window.innerHeight - ekranBosluk) {
            top = window.innerHeight - maxDropdownHeight - ekranBosluk;
        }

        if (top < ekranBosluk) {
            top = ekranBosluk;
        }

        setDropdownPozisyon({
            top,
            left,
            width,
            maxHeight: maxDropdownHeight,
        });
    };


    const contextOptionsPozisyonHesapla = (clientX, clientY) => {
        const bosluk = 12;
        const ekranBosluk = 16;

        const maxMenuWidth = 340;
        const minMenuWidth = 280;
        const maxMenuHeight = Math.min(520, window.innerHeight - ekranBosluk * 2);

        let width = Math.min(maxMenuWidth, window.innerWidth - ekranBosluk * 2);
        let left = clientX + bosluk;

        if (left + width > window.innerWidth - ekranBosluk) {
            left = clientX - width - bosluk;
        }

        if (left < ekranBosluk) {
            left = ekranBosluk;
            width = window.innerWidth - ekranBosluk * 2;
        }

        let top = clientY;

        if (top + maxMenuHeight > window.innerHeight - ekranBosluk) {
            top = window.innerHeight - maxMenuHeight - ekranBosluk;
        }

        if (top < ekranBosluk) {
            top = ekranBosluk;
        }

        setContextOptionsPozisyon({
            top,
            left,
            width: Math.max(minMenuWidth, width),
            maxHeight: maxMenuHeight,
        });
    };

    const handleDropdownAcKapat = (e, hucreKey) => {
        e.stopPropagation();

        if (dropdownHucre === hucreKey) {
            setDropdownHucre(null);
            dropdownButtonRef.current = null;
            return;
        }

        dropdownButtonRef.current = e.currentTarget;

        dropdownPozisyonHesapla(e.currentTarget);

        setDropdownHucre(hucreKey);
    };

    const tumSecilenlereAta = (vardiyaId) => {
        if (seciliPersoneller.length === 0) return;

        geriAlKaydiEkle();

        setPersoneller((prev) =>
            prev.map((p) => {
                if (!seciliPersoneller.includes(p.id)) return p;

                return {
                    ...p,
                    shiftler: p.shiftler.map(() => vardiyaId),
                };
            })
        );

        setOptionsOpen(false);
    };

    const secilenleriSil = () => {
        if (seciliPersoneller.length === 0) return;

        geriAlKaydiEkle();

        setPersoneller((prev) =>
            prev.map((p) => {
                if (!seciliPersoneller.includes(p.id)) return p;

                return {
                    ...p,
                    shiftler: p.shiftler.map(() => ""),
                };
            })
        );

        setOptionsOpen(false);
    };

    const satiriKopyala = () => {
        if (seciliPersoneller.length !== 1) return;

        const seciliId = seciliPersoneller[0];
        const personel = personeller.find((p) => p.id === seciliId);

        if (!personel) return;

        setKopyalananSatir([...personel.shiftler]);
        setOptionsOpen(false);
    };

    const satiriYapistir = () => {
        if (!kopyalananSatir || seciliPersoneller.length === 0) return;

        geriAlKaydiEkle();

        setPersoneller((prev) =>
            prev.map((p) => {
                if (!seciliPersoneller.includes(p.id)) return p;

                return {
                    ...p,
                    shiftler: [...kopyalananSatir],
                };
            })
        );

        setOptionsOpen(false);
    };

    useEffect(() => {
        const dropdownAcik = dropdownHucre || optionsOpen;

        if (!dropdownAcik) return;

        const kilitliScrollY = window.scrollY;

        const menuIcindeMi = (target) => {
            if (!(target instanceof Element)) return false;

            return (
                target.closest(".shift-cell-dropdown") ||
                target.closest(".shift-options-menu")
            );
        };

        const handleWheel = (e) => {
            if (menuIcindeMi(e.target)) return;

            e.preventDefault();
        };

        const handleTouchMove = (e) => {
            if (menuIcindeMi(e.target)) return;

            e.preventDefault();
        };

        const handleScroll = () => {
            if (window.scrollY !== kilitliScrollY) {
                window.scrollTo(window.scrollX, kilitliScrollY);
            }
        };

        document.body.classList.add("shift-scroll-locked");

        document.addEventListener("wheel", handleWheel, {
            passive: false,
            capture: true,
        });

        document.addEventListener("touchmove", handleTouchMove, {
            passive: false,
            capture: true,
        });

        window.addEventListener("scroll", handleScroll);

        return () => {
            document.body.classList.remove("shift-scroll-locked");

            document.removeEventListener("wheel", handleWheel, {
                capture: true,
            });

            document.removeEventListener("touchmove", handleTouchMove, {
                capture: true,
            });

            window.removeEventListener("scroll", handleScroll);
        };
    }, [dropdownHucre, optionsOpen]);

    useEffect(() => {
        setSayfa(1);
    }, [arama, pozisyonFiltre, seciliSablonFiltre, sayfaBoyutu, personeller.length, haftaKey]);

    useEffect(() => {
        if (!token) return;

        lokasyonlariGetir();
        vardiyaSablonlariniGetir();
    }, [token]);

    useEffect(() => {
        if (!token) return;

        personelSablonlariniYenile();
    }, [token, seciliLokasyonApiId]);

    useEffect(() => {
        if (!pozisyonFiltre) {
            setSeciliSablonFiltre("");
        }
    }, [pozisyonFiltre]);

    useEffect(() => {
        if (!seciliLokasyonId) return;

        setUndoGecmisi([]);
        setPersoneller([]);
        planGetir();
        return () => planRequestRef.current?.abort();
    }, [seciliLokasyonId, haftaKey]);

    useEffect(() => {
        if (!dropdownHucre) return;

        const handlePozisyonGuncelle = () => {
            if (!dropdownButtonRef.current) {
                setDropdownHucre(null);
                return;
            }

            dropdownPozisyonHesapla(dropdownButtonRef.current);
        };

        window.addEventListener("scroll", handlePozisyonGuncelle, true);
        window.addEventListener("resize", handlePozisyonGuncelle);

        return () => {
            window.removeEventListener("scroll", handlePozisyonGuncelle, true);
            window.removeEventListener("resize", handlePozisyonGuncelle);
        };
    }, [dropdownHucre]);

    useEffect(() => {
        if (!dropdownHucre && !optionsOpen) return;

        const handleDisariTiklama = (event) => {
            const target = event.target;

            const vardiyaDropdownIcinde = target.closest(".shift-cell-dropdown");
            const vardiyaButonuIcinde =
                target.closest(".shift-cell-value") ||
                target.closest(".shift-empty-select");

            const optionsIcinde =
                target.closest(".shift-options-menu") ||
                target.closest(".shift-options-btn");

            if (vardiyaDropdownIcinde || vardiyaButonuIcinde || optionsIcinde) {
                return;
            }

            setDropdownHucre(null);
            setOptionsOpen(false);
        };

        document.addEventListener("click", handleDisariTiklama);

        return () => {
            document.removeEventListener("click", handleDisariTiklama);
        };
    }, [dropdownHucre, optionsOpen]);

    useEffect(() => {
        const fetchProfilePhoto = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_API_BASE_URL}/api/Auth/ppbak`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                        responseType: "blob",
                    }
                );

                const imgUrl = URL.createObjectURL(res.data);
                setProfilePhoto(imgUrl);
            } catch (err) {
                console.error("Profil fotoğrafı alınamadı:", err);
                setProfilePhoto(null);
            }
        };

        if (token) {
            fetchProfilePhoto();
        }

        return () => {
            if (profilePhoto) {
                URL.revokeObjectURL(profilePhoto);
            }
        };
    }, [token]);

    const vardiyaPlanlamaYardim = [
        {
            heading: "Bu sayfa ne işe yarar?",
            text: "Bu ekran, mağazadaki personellerin haftalık vardiya planını hazırlamak için kullanılır. Müdürler bu sayfadan personelin hangi gün hangi vardiyada çalışacağını, hangi gün izinli olacağını veya özel bir durum varsa bunu planlayabilir.",
        },
        {
            heading: "İlk olarak ne yapmalısınız?",
            items: [
                "Önce üst bölümden doğru haftayı seçin.",
                "Ardından işlem yapacağınız lokasyonu kontrol edin.",
                "Personel listesi geldikten sonra arama veya pozisyon filtresiyle listeyi daraltabilirsiniz.",
                "Plan yapmaya başlamadan önce doğru hafta ve doğru mağaza üzerinde olduğunuzdan emin olun.",
            ],
        },
        {
            heading: "Vardiya nasıl atanır?",
            items: [
                "Personelin ilgili gün hücresine tıklayın.",
                "Açılan listeden uygun vardiyayı seçin.",
                "Haftalık izin, rapor, boş gün veya özel izin gibi seçenekleri de aynı listeden verebilirsiniz.",
                "Yanlış seçim yaptıysanız hücreye tekrar tıklayıp farklı vardiya seçebilirsiniz.",
            ],
        },
        {
            heading: "Toplu işlem nasıl kullanılır?",
            items: [
                "Birden fazla personele aynı işlemi yapmak için önce sol taraftaki kutucuklardan personelleri seçin.",
                "Seçim yaptıktan sonra tablo alanına sağ tıklayarak toplu işlem menüsünü açabilirsiniz.",
                "Bu menüden seçili kişilere toplu vardiya atayabilir veya seçili vardiyaları temizleyebilirsiniz.",
                "Toplu işlem yapmadan önce doğru personellerin seçili olduğuna mutlaka dikkat edin.",
            ],
        },
        {
            heading: "Geçen haftayı kopyalama ne işe yarar?",
            items: [
                "Geçen haftaya benzer bir plan yapılacaksa 'Geçen Haftayı Kopyala' butonunu kullanabilirsiniz.",
                "Bu işlem önceki haftadaki vardiya düzenini mevcut haftaya aktarır.",
                "Kopyalama sonrası yine personel bazlı değişiklik yapabilirsiniz.",
                "Kopyalanan planı kontrol etmeden kaydetmeyin.",
            ],
        },
        {
            heading: "Renkler ne anlama gelir?",
            items: [
                "Mavi tonlar normal çalışma vardiyalarını gösterir.",
                "Mor tonlar haftalık izinleri gösterir.",
                "Yeşil tonlar yıllık izin veya bayram izni gibi izinleri gösterir.",
                "Turuncu tonlar rapor veya benzeri özel durumları gösterir.",
                "Gri tonlar boş günleri gösterir.",
                "Renkler, planı hızlı kontrol edebilmeniz için kullanılır.",
            ],
        },
        {
            heading: "Kaydetme konusunda dikkat",
            items: [
                "Yaptığınız değişiklikler 'Değişiklikleri Kaydet' butonuna basılmadan kesinleşmez.",
                "Hafta veya lokasyon değiştirmeden önce planınızı kontrol edin.",
                "Kaydetme işlemi tamamlandığında ekranda başarı mesajı görmelisiniz.",
                "Hata mesajı alırsanız planın kaydedilip kaydedilmediğini kontrol etmeden sayfadan çıkmayın.",
            ],
        },
        {
            heading: "En sık yapılan hatalar",
            items: [
                "Yanlış hafta seçiliyken plan yapmak.",
                "Yanlış lokasyon üzerinde vardiya girmek.",
                "Toplu işlemde yanlış personelleri seçmek.",
                "Planı düzenleyip kaydetmeden sayfadan çıkmak.",
                "İzinli personele yanlışlıkla çalışma vardiyası vermek.",
            ],
        },
    ];

    const handleTabloScroll = () => {
        if (!tabloScrollRef.current || !altScrollRef.current) return;

        altScrollRef.current.scrollLeft = tabloScrollRef.current.scrollLeft;
    };

    const handleAltScroll = () => {
        if (!tabloScrollRef.current || !altScrollRef.current) return;

        tabloScrollRef.current.scrollLeft = altScrollRef.current.scrollLeft;
    };

    useEffect(() => {
        const tabloGenisliginiGuncelle = () => {
            if (!tabloScrollRef.current) return;

            const rect = tabloScrollRef.current.getBoundingClientRect();

            setTabloScrollWidth(tabloScrollRef.current.scrollWidth);
            setAltScrollStyle({
                left: rect.left,
                width: rect.width,
            });
        };

        tabloGenisliginiGuncelle();

        window.addEventListener("resize", tabloGenisliginiGuncelle);
        window.addEventListener("scroll", tabloGenisliginiGuncelle);

        return () => {
            window.removeEventListener("resize", tabloGenisliginiGuncelle);
            window.removeEventListener("scroll", tabloGenisliginiGuncelle);
        };
    }, [sayfadakiPersoneller, haftaTarihleri, vardiyaSecenekleri, sidebarGorunur]);

    return (
        <div className="shift-admin-page">
            <div className="shift-normal-navbar-mobile-only">
                <Navbar />
            </div>

            <aside
                className={`shift-sidebar ${sidebarGorunur ? "" : "kapali"}`}
                onMouseEnter={() => {
                    if (!sidebarAcik) {
                        setSidebarHover(true);
                    }
                }}
                onMouseLeave={() => {
                    if (!sidebarAcik) {
                        setSidebarHover(false);
                    }
                }}
            >
                <div className="shift-profile-box">

                    <div className="shift-profile-info">
                        {profilePhoto ? (
                            <img src={profilePhoto} alt={tx("Profil")} />
                        ) : (
                            <div className="shift-profile-placeholder">
                                <UserRound size={24} strokeWidth={2.2} />
                            </div>
                        )}

                        {sidebarGorunur && (
                            <div>
                                <strong>{kullaniciAdi}</strong>
                                <span>{kullaniciEmail}</span>
                            </div>
                        )}
                    </div>

                    <button
                        type="button"
                        className="shift-sidebar-toggle"
                        onClick={() => {
                            setSidebarAcik((prev) => !prev);
                            setSidebarHover(false);
                        }}
                        title={sidebarAcik ? "Menüyü Kapat" : "Menüyü Sabitle"}
                        aria-label={sidebarAcik ? "Menüyü Kapat" : "Menüyü Aç"}
                    >
                        {sidebarAcik ? (
                            <PanelLeftClose size={18} strokeWidth={2.4} />
                        ) : (
                            <PanelLeftOpen size={18} strokeWidth={2.4} />
                        )}
                    </button>
                </div>
                <div className="shift-menu-group">
                    {magazaMuduruMu && (
                        <>
                            {sidebarGorunur && (
                                <span className="shift-menu-group-title">{tx("MÜDÜR DASHBOARD")}</span>
                            )}
                            <button
                                type="button"
                                onClick={() => navigate("/profil", { state: { aktifMenu: "ekipEgitimDurumu" } })}
                                title="Dashboard"
                            >
                                <span className="shift-menu-icon">
                                    <LayoutDashboard size={20} strokeWidth={2.2} />
                                </span>
                                {sidebarGorunur && (
                                    <span className="shift-menu-text">Dashboard</span>
                                )}
                            </button>
                        </>
                    )}

                    {sidebarGorunur && (
                        <span className="shift-menu-group-title">{tx("VARDİYA YÖNETİMİ")}</span>
                    )}

                    <button
                        type="button"
                        className={aktifShiftSayfa === "planlama" ? "active-purple" : ""}
                        onClick={() => setAktifShiftSayfa("planlama")}
                        title={tx("Vardiya Planlama")}
                    >
                        <span className="shift-menu-icon">
                            <CalendarClock size={20} strokeWidth={2.2} />
                        </span>

                        {sidebarGorunur && (
                            <span className="shift-menu-text">{tx("Vardiya Planlama")}</span>
                        )}
                    </button>

                    <button
                        type="button"
                        className={aktifShiftSayfa === "sablonlarim" ? "active-purple" : ""}
                        onClick={() => setAktifShiftSayfa("sablonlarim")}
                        title={tx("Şablonlarım")}
                    >
                        <span className="shift-menu-icon">
                            <FileText size={20} strokeWidth={2.2} />
                        </span>

                        {sidebarGorunur && (
                            <span className="shift-menu-text">{tx("Şablonlarım")}</span>
                        )}
                    </button>

                    <button
                        type="button"
                        className={aktifShiftSayfa === "gunlukRapor" ? "active-purple" : ""}
                        onClick={() => setAktifShiftSayfa("gunlukRapor")}
                        title={tx("Vardiya Günlük Rapor")}
                    >
                        <span className="shift-menu-icon">
                            <ClipboardList size={20} strokeWidth={2.2} />
                        </span>

                        {sidebarGorunur && (
                            <span className="shift-menu-text">{tx("Vardiya Günlük Rapor")}</span>
                        )}
                    </button>

                    <button
                        type="button"
                        className={aktifShiftSayfa === "puantaj" ? "active-purple" : ""}
                        onClick={() => setAktifShiftSayfa("puantaj")}
                        title={tx("Puantaj")}
                    >
                        <span className="shift-menu-icon">
                            <FileText size={20} strokeWidth={2.2} />
                        </span>

                        {sidebarGorunur && <span className="shift-menu-text">{tx("Puantaj")}</span>}
                    </button>

                    <button
                        type="button"
                        className="shift-profile-back-btn"
                        onClick={() => navigate("/profil")}
                        title={tx("Profile Dön")}
                    >
                        <span className="shift-menu-icon">
                            <ArrowLeft size={20} strokeWidth={2.2} />
                        </span>

                        {sidebarGorunur && <span className="shift-menu-text">{tx("Profile Dön")}</span>}
                    </button>
                </div>

            </aside>

            <main className="shift-main" onContextMenu={handleTopluSagTik}>

                {aktifShiftSayfa === "planlama" && (
                    <>
                        <section className="shift-filter-card">
                            <div className="sayfa-baslik-row">
                                <h1>{tx("Vardiya Planlama")}</h1>

                                <button
                                    type="button"
                                    className="sayfa-yardim-btn"
                                    onClick={() => setYardimAcik(true)}
                                    title={tx("Sayfa yardımı")}
                                >
                                    ?
                                </button>
                            </div>


                            <div className="shift-filter-grid">
                                <label>{tx("Tarih")}<div className="shift-week-control">
                                        <button
                                            type="button"
                                            onClick={() => haftaDegistir("geri")}
                                            title={tx("Önceki hafta")}
                                        >
                                            ‹
                                        </button>

                                        <div className="shift-week-date-box">
                                            <div className="shift-week-date-text">
                                                <span>
                                                    {formatDate(haftaTarihleri[0],lang)} -{" "}
                                                    {formatDate(haftaTarihleri[6],lang)}
                                                </span>

                                                <small>{getIsoWeekNumber(haftaBaslangic)} · {tx("Hafta")}</small>
                                            </div>

                                            <input
                                                type="date"
                                                className="shift-date-picker-input"
                                                value={formatDateForApi(haftaBaslangic)}
                                                onChange={tarihSecildi}
                                                title={tx("Tarih seç")}
                                            />
                                        </div>

                                        <button
                                            type="button"
                                            onClick={() => haftaDegistir("ileri")}
                                            title={tx("Sonraki hafta")}
                                        >
                                            ›
                                        </button>

                                        <button
                                            type="button"
                                            className="shift-this-week-btn"
                                            onClick={buHaftayaDon}
                                        >{tx("Bu Hafta")}</button>
                                    </div>
                                </label>

                                <label>{tx("Lokasyon")}<div className="shift-input-like">

                                        <select
                                            value={seciliLokasyonId}
                                            onChange={(e) => setSeciliLokasyonId(e.target.value)}
                                        >
                                            <option value="">{tx("Lokasyon seçiniz")}</option>
                                            {lokasyonSelectListesi.map((lokasyon) => (
                                                <option
                                                    key={lokasyon.id}
                                                    value={lokasyon.id}
                                                    className={lokasyon.anaBaslikMi ? "lokasyon-ana-option" : "lokasyon-alt-option"}
                                                >
                                                    {lokasyon.gorunenAd}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </label>

                                <label>{tx("Kullanıcılar")}<div className="shift-input-like">
                                        <input
                                            placeholder={tx("Kullanıcı Ara")}
                                            value={arama}
                                            onChange={(e) => setArama(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    planGetir();
                                                }
                                            }}
                                        />
                                    </div>
                                </label>
                                <label>{tx("Pozisyon")}<div className="shift-input-like">
                                        <select
                                            value={pozisyonFiltre}
                                            onChange={(e) => setPozisyonFiltre(e.target.value)}
                                        >
                                            <option value="">{tx("Tüm Pozisyonlar")}</option>

                                            {pozisyonSecenekleri.map((pozisyon) => (
                                                <option key={pozisyon} value={pozisyon}>
                                                    {pozisyon}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </label>

                                <label>{tx("Şablonlar")}<div className="shift-input-like">
                                        <select
                                            value={seciliSablonFiltre}
                                            onChange={(e) => setSeciliSablonFiltre(e.target.value)}
                                        >
                                            <option value="">{tx("Tüm Şablonlar")}</option>

                                            {sablonFiltreSecenekleri.map((sablon) => (
                                                <option key={sablon.id} value={sablon.id}>
                                                    {sablon.ad}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </label>

                            </div>

                        </section>

                        {apiHata && (
                            <div className="shift-api-error">
                                {apiHata}
                            </div>
                        )}

                        {veriYukleniyor && (
                            <div className="shift-api-loading">{tx("Veriler yükleniyor...")}</div>
                        )}


                        <section className="shift-record-card">
                            <div className="shift-record-header">
                                <div className="shift-record-title-wrap">

                                    <div className="shift-legend">
                                        <div className="shift-legend-item">
                                            <span className="shift-legend-dot calisma"></span>
                                            <span>{tx("Çalışma")}</span>
                                        </div>

                                        <div className="shift-legend-item">
                                            <span className="shift-legend-dot haftalik-izin"></span>
                                            <span>{tx("Haftalık İzin")}</span>
                                        </div>

                                        <div className="shift-legend-item">
                                            <span className="shift-legend-dot yillik-izin"></span>
                                            <span>{tx("Yıllık / Bayram İzni")}</span>
                                        </div>

                                        <div className="shift-legend-item">
                                            <span className="shift-legend-dot ozel-izin"></span>
                                            <span>{tx("Özel İzin")}</span>
                                        </div>

                                        <div className="shift-legend-item">
                                            <span className="shift-legend-dot rapor"></span>
                                            <span>{tx("Rapor")}</span>
                                        </div>

                                        <div className="shift-legend-item">
                                            <span className="shift-legend-dot yarim-calisma"></span>
                                            <span>{tx("Yarım Çalışma")}</span>
                                        </div>

                                        <div className="shift-legend-item">
                                            <span className="shift-legend-dot bos"></span>
                                            <span>{tx("Boş")}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="shift-record-actions">
                                    {optionsOpen && (
                                        <div
                                            className="shift-options-menu"
                                            onClick={(e) => e.stopPropagation()}
                                            style={{
                                                top: contextOptionsPozisyon.top,
                                                left: contextOptionsPozisyon.left,
                                                width: contextOptionsPozisyon.width,
                                                maxHeight: contextOptionsPozisyon.maxHeight,
                                            }}
                                        >
                                            <button onClick={gecenHaftayiKopyala}>{tx("Geçen Haftayı Kopyala")}</button>

                                            <button>{tx("Etiket Ekle")}</button>

                                            <button onClick={secilenleriSil}>{tx("Seçilen Vardiyaları Sil")}</button>

                                            <hr />

                                            <button
                                                disabled={seciliPersoneller.length !== 1}
                                                onClick={satiriKopyala}
                                            >{tx("Bu satırın vardiyalarını kopyala")}</button>

                                            <button
                                                disabled={!kopyalananSatir || seciliPersoneller.length === 0}
                                                onClick={satiriYapistir}
                                            >{tx("Kopyalanan vardiyaları seçili satırlara yapıştır")}</button>

                                            <hr />

                                            <p>{tx("Tüm Seçilenlere Vardiya Ata")}</p>

                                            {sablonVardiyaSecenekleri.map((v) => (
                                                <button
                                                    key={v.id}
                                                    onClick={() => tumSecilenlereAta(v.id)}
                                                >
                                                    {tx(v.label)}
                                                </button>
                                            ))}
                                        </div>
                                    )}

                                    <button
                                        type="button"
                                        className="shift-copy-week-btn"
                                        onClick={gecenHaftayiKopyala}
                                    >{tx("Geçen Haftayı Kopyala")}</button>

                                    <button
                                        type="button"
                                        className="shift-undo-btn"
                                        onClick={sonDegisikligiGeriAl}
                                        disabled={undoGecmisi.length === 0 || veriYukleniyor}
                                    >{tx("Son Değişikliği Geri Al")}</button>

                                    <button
                                        className="shift-save-btn"
                                        onClick={kaydet}
                                        disabled={veriYukleniyor}
                                    >
                                        {veriYukleniyor ? "Kaydediliyor..." : "Değişiklikleri Kaydet"}
                                    </button>
                                </div>
                            </div>

                            <div
                                className="shift-table-box"
                                ref={tabloScrollRef}
                                onScroll={handleTabloScroll}
                            >
                                <table className="shift-plan-table">
                                    <thead>
                                        <tr>
                                            <th className="check-col">
                                                <input
                                                    type="checkbox"
                                                    checked={tumSeciliMi}
                                                    onChange={toggleTumSec}
                                                />
                                            </th>

                                            <th className="user-col">{tx("KULLANICI")}</th>
                                            <th className="tag-col">{tx("ETİKET")}</th>
                                            <th className="template-col">{tx("REYON")}</th>

                                            {haftaTarihleri.map((tarih, index) => (
                                                <th key={index} className="day-col">
                                                    <strong>{formatDate(tarih,lang)}</strong>
                                                    <span>{tx(gunler[index])}</span>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {sayfadakiPersoneller.map((p) => (
                                            <tr
                                                key={p.id}
                                                className={
                                                    seciliPersoneller.includes(p.id) ? "selected-row" : ""
                                                }
                                            >
                                                <td className="check-col">
                                                    <input
                                                        type="checkbox"
                                                        checked={seciliPersoneller.includes(p.id)}
                                                        onChange={() => togglePersonel(p.id)}
                                                    />
                                                </td>

                                                <td className="user-col">
                                                    <div className="shift-user-cell">
                                                        <PersonnelPhoto className="shift-avatar"
                                                            endpoint={p.profilFotoEndpoint}
                                                            name={p.ad} initials={p.avatar} />
                                                        <div>
                                                            <strong>{p.ad}</strong>
                                                            <span>{p.pozisyon}</span>
                                                            <em className={`shift-week-total ${personelHaftalikToplamClass(p)}`}>
                                                                {personelHaftalikToplamYazi(p)}
                                                            </em>                                                        </div>
                                                    </div>
                                                </td>

                                                <td className="tag-col">
                                                    {p.etiket ? (
                                                        <span className="shift-tag">{p.etiket}</span>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </td>

                                                <td className="template-col">
                                                    {aktifPersonelSablonlari.length > 0 ? (
                                                        <select
                                                            className="shift-reyon-select"
                                                            value={personelReyonSablonIdGetir(p)}
                                                            onChange={(e) =>
                                                                personelReyonSablonDegistir(p.id, e.target.value)
                                                            }
                                                        >
                                                            <option value="">{tx("Reyon seç")}</option>

                                                            {aktifPersonelSablonlari.map((sablon) => (
                                                                <option key={sablon.id} value={sablon.id}>
                                                                    {sablon.ad}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    ) : (
                                                        <span className="shift-reyon-empty">{tx("Şablon yok")}</span>
                                                    )}
                                                </td>

                                                {p.shiftler.map((vardiyaId, gunIndex) => {
                                                    const vardiya = getVardiya(vardiyaId);
                                                    const hucreKey = `${p.id}-${gunIndex}`;
                                                    const dropdownAcik = dropdownHucre === hucreKey;

                                                    return (
                                                        <td
                                                            key={gunIndex}
                                                            className="shift-day-cell"
                                                            onContextMenu={(e) => handleHucreSagTik(e, hucreKey)}
                                                        >
                                                            {vardiya ? (
                                                                <button
                                                                    className={`shift-cell-value 
                                                                      ${vardiya.tip !== "calisma" ? "izin" : ""}
                                                                       ${dropdownAcik ? "active-cell" : ""}
                                                                     `}
                                                                    style={getVardiyaHucreStyle(vardiya)}
                                                                    onClick={(e) =>
                                                                        handleDropdownAcKapat(e, hucreKey)
                                                                    }
                                                                >
                                                                    {vardiya.tip !== "calisma" ? (
                                                                        <strong>{vardiya.label}</strong>
                                                                    ) : (
                                                                        <>
                                                                            <strong>{vardiyaToplamSureYazi(vardiya)}</strong>

                                                                            {vardiya.molaDakika !== null &&
                                                                                vardiya.molaDakika !== undefined &&
                                                                                vardiya.molaDakika !== "" && (
                                                                                    <small>{vardiya.molaDakika}{tx("dk mola")}</small>
                                                                                )}

                                                                            <span>{vardiya.saat}</span>
                                                                        </>
                                                                    )}
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className={`shift-empty-select ${dropdownAcik ? "active-cell" : ""}`}
                                                                    onClick={(e) =>
                                                                        handleDropdownAcKapat(e, hucreKey)
                                                                    }
                                                                >
                                                                    ⌄
                                                                </button>
                                                            )}

                                                            {dropdownAcik && (
                                                                <div
                                                                    className="shift-cell-dropdown"
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    style={{
                                                                        top: dropdownPozisyon.top,
                                                                        left: dropdownPozisyon.left,
                                                                        width: dropdownPozisyon.width,
                                                                        maxHeight: dropdownPozisyon.maxHeight,
                                                                    }}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        className="dropdown-title"
                                                                        onClick={() => ozelVardiyaModalAc(p.id, gunIndex)}
                                                                    >{tx("Özel Vardiya Ekle")}</button>

                                                                    <button
                                                                        type="button"
                                                                        className="shift-clear-cell-btn"
                                                                        onClick={() => vardiyaAta(p.id, gunIndex, "")}
                                                                    >{tx("Vardiyayı Temizle")}</button>

                                                                    {sablonVardiyaSecenekleri.length === 0 && (
                                                                        <button disabled>{tx("Vardiya şablonu bulunamadı")}</button>
                                                                    )}


                                                                    {vardiyaSecenekleri.map((secenek) => (
                                                                        <button
                                                                            type="button"
                                                                            key={secenek.id}
                                                                            onClick={() => vardiyaAta(p.id, gunIndex, secenek.id)}
                                                                        >
                                                                            {tx(secenek.label)}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {aktifShiftSayfa === "planlama" && (
                                <div
                                    className="shift-bottom-horizontal-scroll"
                                    ref={altScrollRef}
                                    onScroll={handleAltScroll}
                                    style={{
                                        left: `${altScrollStyle.left}px`,
                                        width: `${altScrollStyle.width}px`,
                                    }}
                                >
                                    <div style={{ width: `${tabloScrollWidth}px` }} />
                                </div>
                            )}

                            <div className="shift-table-footer">
                                <span>{seciliPersoneller.length}{tx("kişi seçildi")}</span>

                                <div className="shift-pagination">
                                    <span>{tx("Sayfa başı:")}</span>

                                    <select
                                        value={sayfaBoyutu}
                                        onChange={sayfaBoyutuDegistir}
                                        className="shift-page-size-select"
                                    >
                                        <option value={10}>{tx("10 kişi")}</option>
                                        <option value={20}>{tx("20 kişi")}</option>
                                        <option value={50}>{tx("50 kişi")}</option>
                                    </select>

                                    <span>
                                        {listeBaslangic}-{listeBitis} / {filtreliPersoneller.length}
                                    </span>

                                    <button
                                        type="button"
                                        onClick={oncekiSayfa}
                                        disabled={sayfa <= 1}
                                        title={tx("Önceki sayfa")}
                                    >
                                        ‹
                                    </button>

                                    <button
                                        type="button"
                                        onClick={sonrakiSayfa}
                                        disabled={sayfa >= toplamSayfa}
                                        title={tx("Sonraki sayfa")}
                                    >
                                        ›
                                    </button>
                                </div>
                            </div>

                        </section>



                    </>
                )}
                {aktifShiftSayfa === "sablonlarim" && (
                    <section className="shift-template-page">
                        <div className="shift-template-header">
                            <div>
                                <h1>{tx("Şablonlarım")}</h1>
                                <p>{tx("Mağazanızdaki reyonları buradan tanımlayabilirsiniz.")}</p>
                            </div>

                            <span>
                                {personelSablonYukleniyor
                                    ? "Yükleniyor..."
                                    : `${personelSablonlari.length} şablon`}
                            </span>
                        </div>

                        <div className="shift-template-layout">
                            <div className="shift-template-form-card">
                                <h3>
                                    {duzenlenenPersonelSablonId
                                        ? "Şablonu Düzenle"
                                        : "Yeni Şablon Ekle"}
                                </h3>

                                <div className="shift-template-form">
                                    <label>{tx("Şablon Adı")}<input
                                            value={personelSablonForm.ad}
                                            onChange={(e) =>
                                                personelSablonFormDegistir("ad", e.target.value)
                                            }
                                            placeholder={tx("Örn: Erkek, Kadın, Çocuk, Kasa")}
                                        />
                                    </label>

                                    <div className="shift-template-form-actions">
                                        <button
                                            type="button"
                                            className="shift-save-btn"
                                            onClick={personelSablonKaydet}
                                            disabled={personelSablonYukleniyor}
                                        >
                                            {duzenlenenPersonelSablonId ? "Güncelle" : "Şablon Ekle"}
                                        </button>

                                        {duzenlenenPersonelSablonId && (
                                            <button
                                                type="button"
                                                className="shift-undo-btn"
                                                onClick={personelSablonFormTemizle}
                                            >{tx("Vazgeç")}</button>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="shift-template-list-card">
                                <div className="shift-template-list-head">
                                    <h3>{tx("Kayıtlı Şablonlar")}</h3>
                                    <small>{tx("Bu kayıtlar daha sonra vardiya planlama ekranında seçilecek.")}</small>
                                </div>

                                {personelSablonlari.length === 0 ? (
                                    <div className="shift-template-empty">{tx("Henüz şablon eklenmedi.")}</div>
                                ) : (
                                    <div className="shift-template-list">
                                        {personelSablonlari.map((sablon) => (
                                            <div className="shift-template-item" key={sablon.id}>
                                                <div>
                                                    <strong>{sablon.ad}</strong>
                                                    <span>
                                                        {sablon.ad || sablon.reyon}
                                                    </span>
                                                    <small>{lokasyonAdiGetir(sablon.lokasyonId)}</small>
                                                </div>

                                                <div className="shift-template-card-actions">
                                                    <button
                                                        type="button"
                                                        className="shift-edit-btn"
                                                        onClick={() => personelSablonDuzenle(sablon)}
                                                    >{tx("Düzenle")}</button>

                                                    <button
                                                        type="button"
                                                        className="shift-delete-btn"
                                                        onClick={() => personelSablonSilIste(sablon)}
                                                        disabled={personelSablonYukleniyor}
                                                    >{tx("Sil")}</button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                )}
                {aktifShiftSayfa === "gunlukRapor" && <VardiyaGunlukRapor />}

                {aktifShiftSayfa === "puantaj" && <Puantaj />}

            </main>
            {ozelVardiyaModal.acik && (
                <div className="shift-ozel-modal-backdrop" onClick={ozelVardiyaModalKapat}>
                    <div
                        className="shift-ozel-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="shift-ozel-modal-head">
                            <h3>{tx("Özel Vardiya Ekle")}</h3>

                            <button type="button" onClick={ozelVardiyaModalKapat}>
                                ×
                            </button>
                        </div>

                        <div className="shift-ozel-modal-grid">
                            <label>{tx("Başlangıç Saati")}<input
                                    type="time"
                                    value={ozelVardiyaModal.baslangicSaati}
                                    onChange={(e) =>
                                        setOzelVardiyaModal((prev) => ({
                                            ...prev,
                                            baslangicSaati: e.target.value,
                                        }))
                                    }
                                />
                            </label>

                            <label>{tx("Bitiş Saati")}<input
                                    type="time"
                                    value={ozelVardiyaModal.bitisSaati}
                                    onChange={(e) =>
                                        setOzelVardiyaModal((prev) => ({
                                            ...prev,
                                            bitisSaati: e.target.value,
                                        }))
                                    }
                                />
                            </label>

                            <label>{tx("Mola Dakika")}<input
                                    type="number"
                                    min="0"
                                    placeholder={tx("Boş bırakılabilir")}
                                    value={ozelVardiyaModal.molaDakika}
                                    onChange={(e) =>
                                        setOzelVardiyaModal((prev) => ({
                                            ...prev,
                                            molaDakika: e.target.value,
                                        }))
                                    }
                                />
                            </label>

                            <label className="full">{tx("Açıklama")}<textarea
                                    placeholder={tx("İsteğe bağlı açıklama")}
                                    value={ozelVardiyaModal.aciklama}
                                    onChange={(e) =>
                                        setOzelVardiyaModal((prev) => ({
                                            ...prev,
                                            aciklama: e.target.value,
                                        }))
                                    }
                                />
                            </label>
                        </div>

                        <div className="shift-ozel-modal-actions">
                            <button type="button" onClick={ozelVardiyaModalKapat}>{tx("Vazgeç")}</button>

                            <button type="button" onClick={ozelVardiyaKaydet}>{tx("Hücreye Ekle")}</button>
                        </div>
                    </div>
                </div>
            )}

            {bildirim.acik && (
                <div className={`shift-toast ${bildirim.tip}`}>
                    <div className="shift-toast-icon">
                        {bildirim.tip === "success" && "✓"}
                        {bildirim.tip === "warning" && "!"}
                        {bildirim.tip === "error" && "×"}
                    </div>

                    <div className="shift-toast-content">
                        <strong>
                            {bildirim.tip === "success" && "Başarılı"}
                            {bildirim.tip === "warning" && "Uyarı"}
                            {bildirim.tip === "error" && tx("Hata")}
                        </strong>

                        <span>{bildirim.mesaj}</span>
                    </div>

                    <button
                        type="button"
                        className="shift-toast-close"
                        onClick={bildirimKapat}
                    >
                        ×
                    </button>
                </div>
            )}

            <SayfaYardimPopup
                open={yardimAcik}
                onClose={() => setYardimAcik(false)}
                title={tx("Vardiya Planlama Nasıl Kullanılır?")}
                kind="planlama"
                sections={vardiyaPlanlamaYardim}
            />

            {silinecekPersonelSablon && (
                <div className="shift-modal-backdrop">
                    <div className="shift-delete-modal">
                        <h3>{tx("Şablon silinsin mi?")}</h3>

                        <p>
                            <strong>{silinecekPersonelSablon.ad}</strong>{tx("adlı şablon silinecek. Bu işlem geri alınamaz.")}</p>

                        <div className="shift-delete-modal-actions">
                            <button
                                type="button"
                                className="shift-undo-btn"
                                onClick={() => setSilinecekPersonelSablon(null)}
                                disabled={personelSablonYukleniyor}
                            >{tx("Vazgeç")}</button>

                            <button
                                type="button"
                                className="shift-delete-btn"
                                onClick={personelSablonSilOnayla}
                                disabled={personelSablonYukleniyor}
                            >
                                {personelSablonYukleniyor ? "Siliniyor..." : "Evet, Sil"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div >

    );
}


export default ShiftYonetimi;
